const config = {
  contractAddress: "KT19i3iZNfcct4qqZAkP2ZawS7kWF8V6zCMc",
};

export default config;
